import { FormType } from '../../../form-types';
import { TrtFollowupFieldAnswers } from './questions';

const trtFollowup: FormType<TrtFollowupFieldAnswers> = {
  name: 'TRT Follow-up',
  questions: [
    {
      key: 'trtFollowup_sex',
      next: {
        condition: { 'trtFollowup_sex.male': true },
        key: 'trtFollowup_height',
        els: 'trtFollowup_ineligible'
      }
    },
    'trtFollowup_height',
    'trtFollowup_weight',
    {
      key: 'trtFollowup_healthChanges',
      next: {
        condition: {
          'trtFollowup_healthChanges.yes': true
        },
        key: 'trtFollowup_healthChangesDetails',
        els: 'trtFollowup_urgentSymptoms'
      }
    },
    'trtFollowup_healthChangesDetails',
    {
      key: 'trtFollowup_urgentSymptoms',
      next: {
        condition: {
          'trtFollowup_urgentSymptoms.yes': true
        },
        key: 'trtFollowup_ineligible',
        els: 'trtFollowup_medicationDoing'
      }
    },
    {
      key: 'trtFollowup_medicationDoing',
      next: {
        condition: {
          'trtFollowup_medicationDoing.not_well': true
        },
        key: 'trtFollowup_medicationExperience',
        els: 'trtFollowup_sideEffects'
      }
    },
    'trtFollowup_medicationExperience',
    {
      key: 'trtFollowup_sideEffects',
      next: {
        condition: {
          'trtFollowup_sideEffects.yes': true
        },
        key: 'trtFollowup_sideEffectsDetails',
        els: 'trtFollowup_testicularSizeDecrease'
      }
    },
    'trtFollowup_sideEffectsDetails',
    {
      key: 'trtFollowup_testicularSizeDecrease',
      next: {
        condition: {
          'trtFollowup_testicularSizeDecrease.yes': true
        },
        key: 'trtFollowup_ineligible',
        els: 'trtFollowup_lastDoseDate'
      }
    },
    'trtFollowup_lastDoseDate',
    {
      key: 'trtFollowup_doseAdjusted',
      next: {
        condition: {
          'trtFollowup_doseAdjusted.yes_adjusted': true
        },
        key: 'trtFollowup_doseAdjustedDetails',
        els: 'trtFollowup_treatmentPreference'
      }
    },
    'trtFollowup_doseAdjustedDetails',
    'trtFollowup_treatmentPreference',
    'trtFollowup_symptomImprovement',
    'trtFollowup_energyChange',
    'trtFollowup_moodChange',
    'trtFollowup_physicalPerformanceChange',
    'trtFollowup_workConcentrationChange',
    'trtFollowup_sexualFunctionChange',
    'trtFollowup_additionalQuestions',
    {
      key: 'trtFollowup_consent',
      next: {
        switch: [
          {
            condition: {
              'trtFollowup_consent.non_consent': true
            },
            key: 'trtFollowup_didNotConsent'
          }
        ],
        els: 'trtFollowup_complete'
      }
    },
    'trtFollowup_complete',
    'trtFollowup_ineligible',
    'trtFollowup_didNotConsent',
  ]
};

export default trtFollowup;
